export default __webpack_public_path__ + "static/daria-ee806ee98f3b625704ab523a5e660544.png";